export const userStatusConfig = [
    'pending','approved',"rejected"
]